import React from 'react';
import { TipsMapType, TipsMapFunType } from '../index';
import levelupIcon from '@op/assets/svg/levelup.svg';

export const comparePublicationsTips: TipsMapType = {
  en: (
    <>
      The total number of video and text main posts for this game under the
      current filter conditions. Streaming data is not yet included.
    </>
  ),
  zh: <>在当前筛选条件下，本游戏的所有视频和文字贴的总和。暂未包含直播数据。</>,
};

export const compareCreatorTips: TipsMapType = {
  en: (
    <>
      Users who have posted videos or text posts, with duplicates eliminated
      based on channel and username.
    </>
  ),
  zh: (
    <>
      在当前筛选条件下，发布过视频或文字主贴的用户，并依据渠道和用户名进行去重。
    </>
  ),
};

export const compareChannelShareRankingsGameTips: TipsMapFunType = (
  gameName: string,
) => {
  return {
    en: (
      <>
        <b>{gameName}</b>
        <br />
        Click to visit the game's [Feeds] Page. Note: Content may differ after
        redirection as this page uses Levelup data only.
      </>
    ),
    zh: (
      <>
        <b>{gameName}</b>
        <br />
        点击前往该游戏【评论/资讯详情页】，由于当前页面仅包含 Levelup
        数据，跳转后内容可能和当前页面不完全一致。
      </>
    ),
  };
};

export const compareRankingsGameItemTips: TipsMapType = {
  en: <>Click to view details</>,
  zh: <>点击查看详情</>,
};

export const compareRankingsGameLevelUpTips: TipsMapType = {
  en: (
    <>
      To ensure ranking objectivity, all data on this page is sourced from
      <img style={{ width: 60, marginLeft: 5 }} src={levelupIcon}></img>. As
      DataBrain integrates data from Levelup and our own sources, data on
      detailed opinions pages of each game may differ from this page.
    </>
  ),
  zh: (
    <>
      为确保排名客观性，该页所有数据均来自
      <img style={{ width: 60, marginLeft: 5 }} src={levelupIcon}></img>
      。由于DataBrain整合了Levelup及自有数据，游戏 DataBrain
      详情页的数据可能与该页面存在差异。
    </>
  ),
};

export const compareRankingsMobileGameTips: TipsMapType = {
  en: (
    <>
      The mobile app currently provides data for the Top 20+ games, with more
      being added regularly.
    </>
  ),
  zh: <>手游目前仅支持查看 Top 20+的游戏数据，持续补充中。</>,
};

export const compareGameNameClickTips: TipsMapType = {
  en: <>Click to visit the game's [Key Metrics] Page.</>,
  zh: <>点击前往该游戏【核心指标页】</>,
};
